//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebhookEntityNotificationType } from './WebhookEntityNotificationType';

export class WebhookDisplayItem extends ItemBase {
    ID: string | null = null;
    Description: string | null = null;
    Url: string | null = null;
    CreatedDate: string = "1970-01-01T00:00:00";
    Enabled: boolean = false;
    LimitToEntityNotificationTypes: WebhookEntityNotificationType[] = [];

    constructor(initializer?: Partial<WebhookDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebhookDisplayItem";
}
